import { useQuery } from "@tanstack/react-query";
import SharedRecordAPI from "../../api/SharedRecordAPI";
import { SharedRecordsField } from "../../../types/GlobalInterfaces";

interface Props {
  recordID: string;
}

interface Result {
  record: SharedRecordsField | null;
  expired: boolean;
}

export default function useUserSharedRecord({ recordID }: Props) {
  const sharedRecord = useQuery<Result>({
    queryKey: ["userSharedRecord", recordID],
    queryFn: () =>
      SharedRecordAPI.getUserSharedRecord(recordID).then(
        (data) => data?.data?.data
      ),
    enabled: !!recordID,
  });

  return {
    sharedRecord: (sharedRecord.data?.record as SharedRecordsField) || null,
    expired: sharedRecord.data?.expired ?? true,
    sharedRecordLoading: sharedRecord.isLoading,
  };
}
